import * as React from "react";

import { List, ListItem, ListItemText } from "@mui/material";

import { NOT_PROVIDED } from "../common/sudCard";
import { WeblinkListItem } from "./WeblinkListItem";

const SudList = ({
  referenceNumber,
  borough,
  deliveryYear,
  weblink,
  deliveryOrg,
}) => {
  return (
    <List disablePadding>
      {/* <ListItem disablePadding dense>
        <ListItemText
          primary="Reference Number"
          secondary={referenceNumber || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem> */}
      <ListItem disablePadding dense>
        <ListItemText
          primary="Borough"
          secondary={borough || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem>
      <ListItem disablePadding dense>
        <ListItemText
          primary="Delivery Year"
          secondary={deliveryYear || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem>
      <ListItem disablePadding dense>
        <ListItemText
          primary="Main Delivery Organisation or Mechanism"
          secondary={deliveryOrg || NOT_PROVIDED}
          sx={{ mb: 0 }}
        />
      </ListItem>
      <WeblinkListItem weblink={weblink} />
    </List>
  );
};

export default SudList;
